module.exports = __webpack_public_path__ + "assets/img/thumb-Coolabah-Turf-Article.348a9111.jpg";